module.exports = __webpack_public_path__ + "static/media/rodovias-fim-mobile.51b28b12.png";